

TPS.DealerTools = {

    PartnerLookup: {
        pnlSearchForm: null,
        pnlSearchResults: null,
        pnlSelectedCompany: null,
        inputSelectedCompanyID: null,
        btnBackToSearch: null,

        init: function () {
            TPS.DealerTools.PartnerLookup.pnlSearchForm = document.getElementById('pnlSearchForm');
            TPS.DealerTools.PartnerLookup.pnlSearchResults = document.getElementById('pnlSearchResults');
            TPS.DealerTools.PartnerLookup.pnlSelectedCompany = document.getElementById('pnlSelectedCompany');
            TPS.DealerTools.PartnerLookup.inputSelectedCompanyID = document.getElementById('selectedCompanyID');
            TPS.DealerTools.PartnerLookup.btnBackToSearch = document.getElementById('btnBackToSearch');

            if (TPS.DealerTools.PartnerLookup.inputSelectedCompanyID) {
                TPS.DealerTools.PartnerLookup.inputSelectedCompanyID.addEventListener('change', TPS.DealerTools.PartnerLookup.handleCompanySelected);
            }

            if (TPS.DealerTools.PartnerLookup.btnBackToSearch) {
                TPS.DealerTools.PartnerLookup.btnBackToSearch.addEventListener('click', TPS.DealerTools.PartnerLookup.backToSearch);
            }

            TPS.Util.loadWebserviceJS('CMSApp.AV.API.Company');
        },

        handleCompanySelected: function (e) {
            var companyID = TPS.DealerTools.PartnerLookup.inputSelectedCompanyID.value;

            CMSApp.AV.API.Company.GetCompanyInfo(companyID, function (d) {
                if (d.length > 0) {
                    var companyName = document.getElementById('selectedCompanyTitle');
                    var planName = document.getElementById('selectedCompanyPlanName');
                    var administrator = document.getElementById('selectedCompanyPlanAdministrator');
                    var address = document.getElementById('selectedCompanyAddress');

                    var selectedCompanyAdministratorSection = document.getElementById('selectedCompanyAdministratorSection');
                    var selectedCompanyAddressSection = document.getElementById('selectedCompanyAddressSection');

                    companyName.innerHTML = d[0].Name;
                    planName.innerHTML = d[0].ProgramName;

                    if (d[0].CompanyKeyContact === "") {
                        selectedCompanyAdministratorSection.classList.add('hide');
                        selectedCompanyAddressSection.classList.add('end');
                    } else {
                        selectedCompanyAdministratorSection.classList.remove('hide');
                        selectedCompanyAddressSection.classList.remove('end');
                        administrator.innerHTML = d[0].CompanyKeyContact;
                        if (d[0].CompanyKeyContactTitle !== "") {
                            administrator.innerHTML += '<br/>' + d[0].CompanyKeyContactTitle;
                        }
                        if (d[0].Phone !== "") {
                            administrator.innerHTML += '<br/><a href="tel:' + d[0].Phone + '" target="_blank">' + d[0].Phone + '</a>';
                        }
                        if (d[0].CompanyKeyContactEmail !== "") {
                            administrator.innerHTML += '<br/><a href="mailto:' + d[0].CompanyKeyContactEmail + '" target="_blank">' + d[0].CompanyKeyContactEmail + '</a>';
                        }
                    }

                    var addressText = '';
                    if (d[0].Address !== "") {
                        addressText += d[0].Address;
                    }
                    if (d[0].City !== "") {
                        addressText += '<br/>' + d[0].City;
                        if (d[0].StateDisplayName !== "") {
                            addressText += ', ' + d[0].StateDisplayName;
                        }
                    }
                    if (d[0].Zipcode !== "") {
                        addressText += '<br/>' + d[0].Zipcode;
                        if (d[0].CountryTwoLetterCode !== "") {
                            addressText += ' ' + d[0].CountryTwoLetterCode;
                        }
                    }
                    if (addressText === "") {
                        selectedCompanyAddressSection.classList.add('hide');
                    } else {
                        selectedCompanyAddressSection.classList.remove('hide');
                        address.innerHTML = addressText;
                    }

                    TPS.DealerTools.PartnerLookup.pnlSearchForm.classList.add('hide');
                    TPS.DealerTools.PartnerLookup.pnlSearchResults.classList.add('hide');
                    TPS.DealerTools.PartnerLookup.pnlSelectedCompany.classList.remove('hide');
                }

            }, function (d) { console.log(d); alert('Error while getting the company info'); });
        },

        backToSearch: function () {
            TPS.DealerTools.PartnerLookup.inputSelectedCompanyID.value = '';

            TPS.DealerTools.PartnerLookup.pnlSearchForm.classList.remove('hide');
            TPS.DealerTools.PartnerLookup.pnlSearchResults.classList.remove('hide');
            TPS.DealerTools.PartnerLookup.pnlSelectedCompany.classList.add('hide');
        },
    },

    VinSearch: {
        btnValidateVin: null,
        vinNumberInput: null,
        vinStatusIcons: null,
        btnValidatePin: null,
        btnClearVin: null,
        vinDetails: null,
        offersDetails: null,
        pinVinErros: null,

        OpenPinForm: function (_currentElement, _pinId, _secondaryPin, _tertiaryPin, _newvehicle, _demoloaner, _certified, _overseas, _offerCode) {
            var _self = TPS.DealerTools.VinSearch;

            // Clear all PIN Validation forms
            jQuery('.validate-pin-form').each(function () {
                jQuery(this).remove();
            });
            jQuery('.show-validate-pin').each(function () {
                jQuery(this).removeClass('disabled');
            });

            // Select current form
            var pinActions = _currentElement.closest('.validate-pin-actions');

            if (pinActions) {
                var isFirstRadio = true;

                var _html = `    
                <div class="validate-pin-form">
                    <div class="row">
                        <div class="columns small-12 form-control-wrapper padding-top-2">
                            <fieldset id="pinValidationCategory">
                                <legend>${window.Labels.VehicleSaleType.Legend}</legend>
                `;

                if (_newvehicle) {
                    _html += `<input id="pinValidationCategory_new" type="radio" name="pinValidationCategory" value="NEW" ${isFirstRadio ? 'checked' : ''}>
                            <label for="pinValidationCategory_new">${window.Labels.VehicleSaleType.New}</label>`;
                    isFirstRadio = false;
                }
                if (_demoloaner) {
                    _html += `<input id="pinValidationCategory_demo" type="radio" name="pinValidationCategory" value="DEMO" ${isFirstRadio ? 'checked' : ''}>
                            <label for="pinValidationCategory_demo">${window.Labels.VehicleSaleType.DEMO}</label>`;
                    isFirstRadio = false;
                }
                if (_certified) {
                    _html += `<input id="pinValidationCategory_certified" type="radio" name="pinValidationCategory" value="CBV" ${isFirstRadio ? 'checked' : ''}>
                            <label for="pinValidationCategory_certified">${window.Labels.VehicleSaleType.CBV}</label>`;
                    isFirstRadio = false;
                }
                if (_overseas) {
                    _html += `<input id="pinValidationCategory_osd" type="radio" name="pinValidationCategory" value="OSD" ${isFirstRadio ? 'checked' : ''}>
                            <label for="pinValidationCategory_osd">${window.Labels.VehicleSaleType.OSD}</label>`;
                    isFirstRadio = false;
                }

                _html += `
                            </fieldset>
                        </div>
                    </div>

                    <div class="row">
                        <div class="columns small-12 form-control-wrapper">
                            <fieldset id="vinValidationNumber">
                                <div class="small-12 padding-top-2" id="vinValidationTitle">
                                    <legend class="h3">${window.Labels.VehicleVIN}</legend>
                                </div>
                                <div class="row small-12 vin-check" id="vinCheckContainer">
                                    <div class="columns small-12 medium-5 large-4 vin-check-input">
                                        <label class="margin-bottom-1" for="vinNumberInput">${window.Labels.VehicleVINLabel}</label>
                                        <div class="vin-check-input-container">
                                            <input type="text" name="vinNumberInput" id="vinNumberInput">
                                            <span class="icon-container hide">
                                                <span class="icon fas fa-sync fa-spin hide" aria-hidden="true" data-vin-status-icon="loading"></span>
                                                <span class="icon fa fa-check-circle hide" aria-hidden="true" data-vin-status-icon="correct"></span>
                                                <span class="icon fa fa-times-circle hide" aria-hidden="true" data-vin-status-icon="error"></span>
                                                <span class="icon fa fa-exclamation-triangle hide" aria-hidden="true" data-vin-status-icon="alert"></span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="columns small-12 medium-7 large-8 vin-check-cta">
                                        <a class="button small mobile-full margin-0 verify-vin-eligibility" role="button" tabindex="0"
                                            data-action="verifyvineligibility"
                                            data-pin-id="${_pinId}"
                                            data-program-secondarypin="${_secondaryPin}"
                                            data-program-tertiarypin="${_tertiaryPin}"
                                            data-offercode="${_offerCode}"
                                        >${window.Labels.Buttons.VerifyVIN}</a>
                                        <a class="button small mobile-full margin-0 button-outline clear-vin-info hide" role="button" tabindex="0" data-action="clearvin">${window.Labels.Buttons.ClearVIN}</a>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>

                    <div class="checked-vin-details row margin-top-1 hide" data-info="checked-vin-details"></div>
                    <div class="row margin-top-1" data-info="checked-offers-details"></div>
                </div>
                `;

                pinActions.prepend(_html);

                _self.validatePinForm = jQuery('.validate-pin-form');
                _self.btnValidateVin = jQuery('[data-action="verifyvineligibility"]');
                _self.btnClearVin = jQuery('[data-action="clearvin"]');
                _self.vinNumberInput = jQuery('#vinNumberInput');
                _self.vinDetails = jQuery('[data-info="checked-vin-details"]');
                _self.offersDetails = jQuery('[data-info="checked-offers-details"]');
                _self.pinVinErros = jQuery('[data-error-type="vin-error"]');
                _self.vinStatusIcons = jQuery('[data-vin-status-icon]');

                var programStatus = jQuery(pinActions).data('program-status');
                _self.addInfoNote('NEW', programStatus, pinActions);
                _self.VinCheckInput(_self.vinNumberInput);

                var category = TPS.Forms.getFormVals('.' + TPS.DealerTools.ValidatePinForm.validatePinFormSelector).pinValidationCategory;
                TPS.DealerTools.VinSearch.handleCategories(jQuery('#pinValidationCategory'), category);
            }
        },

        verifyVinEligibility: function ($this) {
            var _self = TPS.DealerTools.VinSearch;

            if (!$this.hasClass('disabled')) {
                var pinVin = jQuery('#vinNumberInput').val().trim();
                var pinId = $this.data('pin-id');
                var secondaryPin = $this.data('program-secondarypin');
                var tertiaryPin = $this.data('program-tertiarypin');
                var currentCulture = document.getElementById('lng').value;
                var offerCode = $this.data('offercode');
                var pinVinContainer = jQuery('#vinCheckContainer');

                // Check VIN input format rules
                const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/i;

                if (vinRegex.test(pinVin)) {
                    _self.VinCheck($this, pinVin, pinId, secondaryPin, tertiaryPin, currentCulture, offerCode);
                } else {
                    jQuery('[data-error-type="vin-error"]').remove();
                    _self.btnClearVin.removeClass('hide');
                    _self.updateVinStatusIcon('error');

                    pinVinContainer.after(`
                        <div class="row columns margin-top-1 error-label" data-error-type="vin-error">
                            <span>${window.validationMessages.pattern.vehicleVin.message}</span>
                        </div>
                    `);
                }
            }
        },

        VinCheck: function (_currentElement, _pinVin, _pinId, _secondaryPin, _tertiaryPin, _culture, _offerCode) {
            var _self = TPS.DealerTools.VinSearch;

            var _pinValidationCategory = TPS.Forms.getFormVals('.' + TPS.DealerTools.ValidatePinForm.validatePinFormSelector).pinValidationCategory;

            _self.btnValidatePin = jQuery(_currentElement).closest('.validate-pin-actions').find('[data-action="showvalidatepin"]');

            // Clear previous VIN status and reset UI
            _self.VinClear('update');

            // load the webservice if it does not exist
            if (typeof CMSApp === 'undefined') {
                TPS.Util.loadWebserviceJS('CMSApp.AV.API.Pin');
            }

            // Block fields while loading data
            _self.updateVinStatusIcon('loading');
            _self.vinNumberInput.prop("disabled", true);
            _self.btnValidateVin.addClass('disabled');


            CMSApp.AV.API.Pin.ValidateVin(_pinVin, _pinId, _pinValidationCategory, _secondaryPin, _tertiaryPin, _culture, function (_d) {

                if (_d) {
                    _self.btnValidatePin.removeClass('disabled');
                    _self.btnValidatePin.data('form-status', true);
                    _self.btnClearVin.removeClass('hide');
                    _self.vinDetails.removeClass('hide');

                    if (_d.Success) {
                        _self.displayVinDetails(_self.vinDetails, _d.Object, true);
                        _self.displayOffers(_self.offersDetails, _offerCode, _secondaryPin, _tertiaryPin);
                        _self.updateVinStatusIcon('loading');
                        _self.updateVinStatusIcon('correct');
                    } else {
                        if (_d.ErrorMessages.length > 0) {
                            var pinVin = jQuery('#vinCheckContainer');

                            _d.ErrorMessages.forEach(element => {
                                var _errorType = '';
                                var _alertIcon = '';

                                if (element.BlockSubmit == true) {
                                    _self.btnValidatePin.addClass('disabled');
                                    _self.btnValidatePin.data('form-status', false);
                                    _self.vinNumberInput.prop("disabled", false);
                                    _self.btnValidateVin.removeClass('disabled');
                                    _self.vinDetails.addClass('hide');
                                } else {
                                    _self.displayOffers(_self.offersDetails, _offerCode, _secondaryPin, _tertiaryPin);
                                }

                                if (element.Key === 'error') {
                                    _self.updateVinStatusIcon('loading');
                                    _self.updateVinStatusIcon('error');
                                    _errorType = 'tps-error-default';
                                    _alertIcon = '<span class="icon fa fa-times-circle" aria-hidden="true" data-vin-status-icon="error"></span>';
                                }
                                else if (element.Key === 'warning') {
                                    _self.updateVinStatusIcon('loading');
                                    _self.updateVinStatusIcon('alert');
                                    _errorType = 'tps-error-alert';
                                    _alertIcon = '<span class="icon fa fa-exclamation-triangle" aria-hidden="true" data-vin-status-icon="alert"></span>';
                                } else {
                                    _self.updateVinStatusIcon('loading');
                                    _self.updateVinStatusIcon('error');
                                }

                                pinVin.after(`<div class="row columns margin-top-1 error-label ${_errorType}" data-error-type="vin-error">
                                                ${_alertIcon}
                                                <span>${element.Value}</span>
                                              </div>`
                                );
                            });

                            if (_d.Object) {
                                _self.btnClearVin.removeClass('hide');
                                _self.vinDetails.removeClass('hide');
                                _self.displayVinDetails(_self.vinDetails, _d.Object, false);
                            }
                        }
                    }
                }
            });
        },

        VinCheckInput: function (_input) {
            var _self = TPS.DealerTools.VinSearch;

            _input.on('beforeinput', function (e) {
                const val = _input.val();
                const selectionStart = this.selectionStart;
                const selectionEnd = this.selectionEnd;

                if (val.length >= 17 && selectionStart === selectionEnd) {
                    if (e.originalEvent.inputType && e.originalEvent.inputType.startsWith('insert')) {
                        e.preventDefault();
                    }
                }
            });

            _input.on('input', function () {
                const vin = _input.val();
                var vinCheckContainer = jQuery('#vinCheckContainer');
                const isValid = /^[A-HJ-NPR-Z0-9]{17}$/i.test(vin);

                if (vin.length > 0) {
                    jQuery('[data-error-type="vin-error"]').remove();

                    if (isValid) {
                        _self.vinStatusIcons.addClass('hide').attr('aria-hidden', 'true');
                        _self.vinStatusIcons.parent().addClass('hide');
                    } else {
                        _self.btnClearVin.removeClass('hide');
                        _self.updateVinStatusIcon('error');

                        vinCheckContainer.after(`
                            <div class="row columns margin-top-1 error-label" data-error-type="vin-error">
                                <span>${window.validationMessages.pattern.vehicleVin.message}</span>
                            </div>
                        `);
                    }
                } else {
                    jQuery('[data-error-type="vin-error"]').remove();
                    _self.vinStatusIcons.addClass('hide').attr('aria-hidden', 'true');
                    _self.vinStatusIcons.parent().addClass('hide');
                }
            });
        },

        VinClear: function (_action) {
            var _self = TPS.DealerTools.VinSearch;

            // Reset all VIN search information
            _self.vinStatusIcons.addClass('hide').attr('aria-hidden', 'true');
            _self.vinStatusIcons.parent().addClass('hide');
            _self.btnValidateVin.removeClass('disabled');
            _self.btnClearVin.addClass('hide');
            _self.vinNumberInput.prop("disabled", false);
            _self.vinDetails.addClass('hide');
            _self.pinVinErros.remove();

            _self.validatePinForm.find('.ErrorLabel').remove();

            if (_self.btnValidatePin) {
                _self.btnValidatePin.addClass('disabled');
                _self.btnValidatePin.data('form-status', false);
            }

            // Remove Vehicle PIN Offers
            var vehiclePINOffers = document.querySelectorAll('.vehicle-pin-offer');
            if (vehiclePINOffers) {
                vehiclePINOffers.forEach(offer => {
                    jQuery(offer).empty().addClass('hide');
                });
            }

            // Remove errors
            var errors = document.querySelectorAll('#vinValidationNumber .error-label');
            if (errors) {
                errors.forEach(error => {
                    error.remove();
                });
            }
            var errorsLabel = document.querySelectorAll('.ErrorLabel');
            if (errorsLabel) {
                errorsLabel.forEach(error => {
                    error.remove();
                });
            }
            var vinNumberInputError = document.querySelector('#vinNumberInput-error');
            if (vinNumberInputError) {
                vinNumberInputError.remove();
            }

            // Clear VIN input and Vehicle Details
            if (_action === 'clear') {
                _self.vinNumberInput.val('');
                _self.vinDetails.empty().addClass('hide');
            }
        },

        handleCategories: function (_element, _selectedCategory) {
            var _self = TPS.DealerTools.VinSearch;

            _self.VinClear('clear');

            var closestPinForm = _element.closest('.validate-pin-actions');
            var validatePinBtn = closestPinForm.find('[data-action="showvalidatepin"]');
            var vinContainer = closestPinForm.find('#vinValidationNumber');
            var checkVinCta = closestPinForm.find('[data-action="verifyvineligibility"]');

            if (_selectedCategory == 'OSD') {
                validatePinBtn.removeClass('disabled');
                validatePinBtn.data('form-status', true);
                vinContainer.addClass('hide');
                validatePinBtn.text(window.Labels.Submit);
            } else if (_selectedCategory == 'CBV') {
                validatePinBtn.removeClass('disabled');
                validatePinBtn.data('form-status', true);
                vinContainer.removeClass('hide');
                checkVinCta.addClass('hide');
                validatePinBtn.text(window.Labels.Submit);
            } else {
                validatePinBtn.addClass('disabled');
                validatePinBtn.data('form-status', false);
                vinContainer.removeClass('hide');
                checkVinCta.removeClass('hide');
                validatePinBtn.text(window.Labels.Buttons.ValidatePIN);
            }

            // if this Js variable is defined and set to false, then
            // we will not show the checkVinCta
            // and we will enable the submit button
            if (typeof window.PinValidation_EnableVistaVINValidation != 'undefined' && !window.PinValidation_EnableVistaVINValidation) {
                checkVinCta.addClass('hide');
                validatePinBtn.removeClass('disabled');
                validatePinBtn.data('form-status', true); 
            }

            var programStatus = jQuery(closestPinForm).data('program-status');
            _self.addInfoNote(_selectedCategory, programStatus, closestPinForm);
        },

        addInfoNote: function (_selectedCategory, _programStatus, _closestPinForm) {
            var vinCheckContainer = jQuery('#vinCheckContainer');
            var categoryTextContainer = _closestPinForm.find('[data-category-text-container]');
            var categoryText = '';

            if (categoryTextContainer) {
                categoryTextContainer.remove();
            }

            if (_selectedCategory && _programStatus) {
                if (_selectedCategory == 'NEW') {
                    categoryText = _programStatus.ProgramNewVehicleInfoText;
                }
                if (_selectedCategory == 'DEMO') {
                    categoryText = _programStatus.ProgramDemoLoanerInfoText;
                }
                if (_selectedCategory == 'CBV') {
                    categoryText = _programStatus.ProgramCertifiedInfoText;
                }
                if (_selectedCategory == 'OSD') {
                    categoryText = _programStatus.ProgramOverseasInfoText;
                }

                if (categoryText != null && categoryText != '') {
                    vinCheckContainer.after(`
                        <div class="row inner-form-row-NEW inner-form-row-DEMO inner-form-row-CBV inner-form-row-OSD margin-top-2" data-category-text-container>
                            <div class="columns small-12 medium-12 large-12">
                                <p class="form-control-info-text vehicle-info-text vehicle-info-text-demo">
                                   <em>${categoryText}</em>
                                </p>
                            </div>
                        </div>
                    `);
                }
            }
        },

        // Helper function to update the VIN status icon based on the type
        updateVinStatusIcon: function (status) {
            var _self = TPS.DealerTools.VinSearch;

            // hide icon
            _self.vinStatusIcons.addClass('hide').attr('aria-hidden', 'true');
            _self.vinStatusIcons.parent().addClass('hide');

            // update icon
            var icon = jQuery(`[data-vin-status-icon="${status}"]`);
            icon.removeClass('hide').attr('aria-hidden', 'false');
            icon.parent().removeClass('hide');
        },

        // Helper function to display VIN details
        displayVinDetails: function (_vinDetails, _vehicleData, _isActive) {
            var _self = TPS.DealerTools.VinSearch;
            var vehicleInfoHtml = "";
            var discountInfoHtml = "";

            if (_vehicleData && typeof _vehicleData == 'object') {
                vehicleInfoHtml = `<div class="column" id="vehicle-info" data-vehicle-info='${_self.EscapeHtml(JSON.stringify(_vehicleData))}'>
                                        <h3>${window.Labels.VehicleInformation}</h3>
                                        <p class="checked-vin-details-text-${_isActive ? 'active' : 'blocked'}">
                                            <strong>${window.Labels.VehicleModelYear}:</strong> ${_vehicleData.VehicleYear}<br/>
                                            <strong>${window.Labels.VehicleModelType}:</strong> ${_vehicleData.VehicleType}<br/>
                                            <strong>${window.Labels.VehicleModelTrim}:</strong> ${_vehicleData.VehicleTrim}<br/>
                                            <strong>${window.Labels.FormPinLookUp.VinNumber}:</strong> ${_vehicleData.VinNumber}<br/>
                                            <strong>${window.Labels.VehicleLocation}:</strong> ${_vehicleData.VehicleLocation} (${_vehicleData.VehicleLocationCode})
                                        </p>
                                    </div>`;

                if (_vehicleData.PinValue) {
                    discountInfoHtml = `<div class="column" id="discount-info">
                                            <h3>${window.Labels.DiscountInformation}</h3>
                                            <p class="checked-vin-details-text-${_isActive ? 'active' : 'blocked'}">
                                                <strong>${window.Labels.FormPinLookUp.PINValue}</strong> ${TPS.DealerTools.PinSearch.formatCurrency(_vehicleData.PinValue)}
                                            </p>
                                        </div>`;
                }
            }

            _vinDetails.html(vehicleInfoHtml + discountInfoHtml);
        },

        EscapeHtml: function (str) {
            return str
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;"); // Or &#x27;
        },

        displayOffers: function (_element, _offerCode, _secondaryPin, _tertiaryPin) {
            var hasOffer = _offerCode !== '';

            var VehicleSecondaryPINHtml = `
                <div class="columns small-12 form-control-wrapper vehicle-pin-offer ${_secondaryPin != true ? 'hide' : ''}">
                    <label for="vehicleSecondaryPIN">${window.Labels.VehicleSecondaryPIN}</label>
                    <input type="text" name="vehicleSecondaryPIN" id="vehicleSecondaryPIN" maxlength="50" placeholder="${window.Labels.VehicleSecondaryPINPlaceHolder}">
                    <p class="form-control-info-text"><em>${hasOffer ? window.Labels.secondaryPinText_offer : window.Labels.secondaryPinText}</em></p>
                </div>`

            var VehicleTertiaryPINHtml = `
                <div class="columns small-12 form-control-wrapper vehicle-pin-offer ${_tertiaryPin != true ? 'hide' : ''}">
                    <label for="vehicleTertiaryPIN">${window.Labels.VehicleTertiaryPIN}</label>
                    <input type="text" name="vehicleTertiaryPIN" id="vehicleTertiaryPIN" maxlength="50" placeholder="${window.Labels.VehicleTertiaryPINPlaceHolder}">
                    <p class="form-control-info-text"><em>${hasOffer ? window.Labels.tertiaryPinText_offer : window.Labels.tertiaryPinText}</em></p>
                </div>`

            _element.html(`${VehicleSecondaryPINHtml} ${VehicleTertiaryPINHtml}`);
        }
    },

    ValidatePinForm: {
        validatePinFormSelector: 'validate-pin-form',
        culture: jQuery('#lng').val(),
        listenerLoaded: false,

        init: function (_secondaryPin, _tertiaryPin, _offerCode, _validateButton) {
            var _self = TPS.DealerTools.ValidatePinForm;
            var validatePinForm = jQuery('.' + _self.validatePinFormSelector);

            validatePinForm.slideDown(function () {
                // load webservices
                TPS.Util.loadWebserviceJS('CMSApp.AV.API.Membership');
                TPS.Util.loadWebserviceJS('CMSApp.AV.API.Pin');

                // Remove possible previous "stuck" validation rules
                if (TPS.Forms.validator && TPS.Forms.validator.settings) {
                    TPS.Forms.validator.settings.rules = {};
                }

                // load form validation
                TPS.Forms.setupClientValidation('.' + _self.validatePinFormSelector);

                // Check VIN input format rules
                const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/i;
                var vinNumber = jQuery('#vinNumberInput').val().trim();
                var vinContainer = jQuery('#vinCheckContainer');

                if (vinRegex.test(vinNumber) || _validateButton.data('program-overseas')) {
                    _self.savePinForm(_validateButton);
                } else {
                    jQuery('[data-error-type="vin-error"]').remove();
                    TPS.DealerTools.VinSearch.updateVinStatusIcon('error');

                    vinContainer.after(`
                        <div class="row columns margin-top-1 error-label" data-error-type="vin-error">
                            <span>${window.validationMessages.pattern.vehicleVin.message}</span>
                        </div>
                    `);
                }
            });
        },

        createValidatePinButton: function (_btnType, _pinId, _secondaryPin, _tertiaryPin, _newVehicle, _demoLoaner, _certified, _overseas, _pinOffer, _pinguid = null, _program = null) {

            var btnHtml = '';

            if (_btnType == 'validatepin') {
                btnHtml += `
                    <div class="row">
                        <div class="columns small-12 form-control-wrapper">
                            <a class="button mobile-full show-validate-pin margin-top-1"
                               data-action="showvalidatepin"
                               data-form-status="false"`;
            } else {
                btnHtml += `<a class="button button-outline revalidate-pin-button"
                               data-action="revalidatepin"`;
            }

            btnHtml += `role="button"
                        tabindex="0"
                        data-pin-id="${_pinId}"
                        data-program-secondarypin="${_secondaryPin}"
                        data-program-tertiarypin="${_tertiaryPin}"
                        data-program-newvehicle="${_newVehicle}"
                        data-program-demoloaner="${_demoLoaner}"
                        data-program-certified="${_certified}"
                        data-program-overseas="${_overseas}"
                        data-offercode="${_pinOffer}"
                        data-pinguid="${_pinguid}"
                        data-program="${_program}">`;

            if (_btnType == 'validatepin') {
                btnHtml += `${window.Labels.Buttons.ValidatePIN} 
                            </a>
                        </div>
                    </div>`
            } else {
                btnHtml += `${window.Labels.Buttons.ReValidatePIN} </a>`;
            }

            return btnHtml;
        },

        savePinForm: function (_validateButton) {
            var detailSection = _validateButton.closest('.detail-page-section');

            if (TPS.Forms.validator.checkForm() && !_validateButton.hasClass('submitting')) {
                _validateButton.addClass('submitting').append(TPS.Util.submitSpinner);

                // get the vals from the form HTML
                var pinID = jQuery(_validateButton).data('pin-id');
                var vinNumber = jQuery('#vinNumberInput').val().trim();

                // if the vin validation returned
                // a data object, lets use those values
                var vehicleInfoString = jQuery('#vehicle-info').attr('data-vehicle-info');
                if (vehicleInfoString) {
                    var vehicleInfo = JSON.parse(vehicleInfoString);
                    pinID = vehicleInfo.PinId;
                    vinNumber = vehicleInfo.VinNumber;
                }

                var vals = TPS.Forms.getFormVals('.' + this.validatePinFormSelector);
                var currentCulture = document.getElementById('lng').value;

                if (vals.pinValidationCategory === "OSD") {
                    vinNumber = "";
                }

                // set these to empty strings when CBV
                // b/c sometimes they have pre-selected values
                // when there is only one year / model / trim
                // returned from the webservice for the PIN
                if (vals.pinValidationCategory === "CBV") {
                    vals.vehicleYear = "";
                    vals.vehicleModel = "";
                    vals.vehicleTrim = "";
                }

                var vehicleExtraInfo = " ";
                vals.vehicleSecondaryPIN = vals.vehicleSecondaryPIN ? vals.vehicleSecondaryPIN : '';
                vals.vehicleTertiaryPIN = vals.vehicleTertiaryPIN ? vals.vehicleTertiaryPIN : '';

                CMSApp.AV.API.Pin.SavePin(
                    pinID,
                    vals.pinValidationCategory,
                    vinNumber,
                    vehicleExtraInfo,
                    vals.vehicleSecondaryPIN,
                    vals.vehicleTertiaryPIN,
                    currentCulture,
                    function (d) {
                        if (d.Success) {
                            if (d.RedirectURL) {
                                // remove form and show worksheet download button
                                detailSection.find('.show-validate-pin, .validate-pin-form').remove();

                                // add Validated text
                                detailSection.find('.heading-highlight').text(window.Labels.FormPinLookUp.PinStatus.VALIDATED);

                                // add download and revalidate buttons
                                var btnWrapper = detailSection.find('.validate-pin-actions');
                                var _dwnBtn = jQuery(`<a href="${d.RedirectURL}" target="_blank" class="button download-worksheet-button">${window.Labels.Buttons.DownloadWorksheet}</a>`);

                                var _reActbtn = jQuery(
                                    TPS.DealerTools.ValidatePinForm.createValidatePinButton(
                                        'revalidatepin',
                                        _validateButton.data('pin-id'),
                                        _validateButton.data('program-secondarypin'),
                                        _validateButton.data('program-tertiarypin'),
                                        _validateButton.data('program-newvehicle'),
                                        _validateButton.data('program-demoloaner'),
                                        _validateButton.data('program-certified'),
                                        _validateButton.data('program-overseas'),
                                        _validateButton.data('offercode'),
                                        btnWrapper.data('pinguid'),
                                        btnWrapper.data('program')
                                    )
                                );

                                btnWrapper.append(_dwnBtn, '&nbsp;', _reActbtn);
                                document.location = d.RedirectURL;
                            }
                        } else {
                            detailSection.find('#vinCheckContainer .tps-error-general').remove();
                            detailSection.find('#vinNumberInput-error').remove();
                            d.ErrorMessages.forEach(element => {
                                detailSection.find('#vinCheckContainer').append('<div class="columns ErrorLabel tps-error-general padding-0">' + element.Value + '</div>');
                            });

                            if (vals.pinValidationCategory === "OSD" || vals.pinValidationCategory === "CBV") {
                                _validateButton.removeClass('disabled');
                                _validateButton.data('form-status', true);
                            }
                        }

                        _validateButton.find('.icon').remove();
                        _validateButton.removeClass('submitting');
                    },
                    function (d) {
                        _validateButton.find('.icon').remove();
                        _validateButton.removeClass('submitting');
                    }

                );

            }

        },

        reactivatePin: function (_reactivatePinBtn, _pinGuid, _wrapper, _pinId, _secondaryPin, _tertiaryPin, _newvehicle, _demoloaner, _certified, _overseas, _offerCode) {

            if (typeof CMSApp === 'undefined') {
                // load the webservice if it does not exist
                TPS.Util.loadWebserviceJS('CMSApp.AV.API.Pin');
            }

            if (_pinGuid && !_reactivatePinBtn.hasClass('submitting')) {
                _reactivatePinBtn.addClass('submitting').append(TPS.Util.submitSpinner);

                CMSApp.AV.API.Pin.ReactivatePin(_pinGuid, function (_d) {
                    if (_d.Success) {
                        // remove the download + reactivate buttons
                        _wrapper.empty();

                        var status = JSON.stringify(_wrapper.data('programStatus'));

                        // create the button
                        var button = TPS.DealerTools.ValidatePinForm.createValidatePinButton(
                            'validatepin',
                            _pinId,
                            _secondaryPin,
                            _tertiaryPin,
                            _newvehicle,
                            _demoloaner,
                            _certified,
                            _overseas,
                            _offerCode,
                            _pinGuid,
                            _wrapper.data('program')
                        );

                        // add the validate button back
                        _wrapper.append(button);

                        // Update the PIN status text
                        var _itemSection = _wrapper.closest('.detail-page-section');
                        _itemSection.find('.heading-highlight').text(window.Labels.FormPinLookUp.PinStatus.ACTIVE);
                        _itemSection.find('.validated-details').remove();

                        _reactivatePinBtn.find('.icon').remove();
                        _reactivatePinBtn.removeClass('submitting');

                    } else {
                        _reactivatePinBtn.find('.icon').remove();
                        _reactivatePinBtn.removeClass('submitting');
                        alert(_d.ErrorMessages[0].Value);
                    }
                });
            }

        }
    },

    DealerSearch: {
        init: function () {
            var locations = jQuery('.participating-dealer-list-item');
            locations.slice(0, 5).show();

            if (locations.length > 5)
                jQuery('.participating-dealer-view-more').show();

            jQuery(document).on('click', '.view-more', function (e) {
                e.preventDefault();

                jQuery(this).hide();
                jQuery('.participating-dealer-list-item').show();
            });
        }
    }
}
